import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';

import './sign.css';

import {
    // Grid,
    // Row,
    // Col,
    FormGroup,
    // InputGroup,
    ControlLabel,
    FormControl,
    HelpBlock
} from "react-bootstrap";

import Button from "components/CustomButton/CustomButton.jsx";

import { auth, db } from "firedb/firebase";

import * as routes from 'constants/routes';

const errCompanyNameEmpty = "Введите название Вашей компании";
const errCompanyNameWrongCharts = "Название содержит недопустимые символы";
const errCompanyNameDefault = "Название некорректно";

const errUserEmailEmpty = "Данное поле не может быть пустым";
const errUserEmailNoValid = "Укажите корректный адрес электронной почты";
const errUserEmailAlreadyInUse = "Данный адрес уже используется";
// const errUserEmailNoAvail = "Данный адрес неактивен";

const errUserPasswordEmpty = "Пароль не может быть пустым";
const errUserPassword = "Пароль должен содержать не менее 6 символов";

const init_state = {
	UserEmail : '',
	UserPasswd : '',
	UserPhone : '',
	CompanyName : '',

	UserEmailValid : null,
	UserPasswdValid : null,
	UserPhoneValid : null,
	CompanyNameValid : null,

	HelpUserEmail : '',
	HelpUserPasswd : '',
	HelpUserPhone : 'Необязательное поле',
	HelpCompanyName : 'Это название будут видеть все Ваши клиенты'
};

class SignUpPage extends Component {
	constructor(props) {
		super(props);

		this.state = {...init_state};

		this.onChangeCompanyName = this.onChangeCompanyName.bind(this);
		this.onChangeUserPhone = this.onChangeUserPhone.bind(this);
		this.onChangeUserEmail = this.onChangeUserEmail.bind(this);
		this.onChangeUserPasswd = this.onChangeUserPasswd.bind(this);

	}

	checkCompanyName = () => {
		if(this.state.CompanyName.length === 0) {
			this.errorCompanyName(errCompanyNameEmpty);
			return false;
		}

		return true;
	}

	checkUserEmail = () => {
		if(this.state.UserEmail.length === 0) {
			this.errorUserEmail(errUserEmailEmpty);
			return false;
		}

		return true;	
	}

	checkUserPassword = () => {
		if(this.state.CompanyName.length === 0) {
			this.errorCompanyName(errUserPasswordEmpty);
			return false;
		}

		return true;	
	}

	checkUserPhone = () => {
		return true;
	}

	errorCompanyName = (error) => {
   		this.setState({HelpCompanyName : error});
		this.setState({CompanyNameValid : "error"});
	}

	errorUserEmail = (error) => {
   		this.setState({HelpUserEmail : error});
		this.setState({UserEmailValid : "error"});
	}

	errorUserPassword = (error) => {
   		this.setState({HelpUserPasswd : error});
		this.setState({UserPasswdValid : "error"});
	}

	errorUserPhone = (error) => {
   		this.setState({HelpUserPhone : error});
		this.setState({UserPhoneValid : "error"});
	}

	noErrorInputs = () => {
   		this.setState({HelpCompanyName : ""});
   		this.setState({HelpUserPhone : ""});
   		this.setState({HelpUserEmail : ""});
   		this.setState({HelpUserPasswd : ""});
   		this.setState({CompanyNameValid : null});
   		this.setState({UserPhoneValid : null});
   		this.setState({UserEmailValid : null});
   		this.setState({UserPasswdValid : null});

	}

	procFirebaseError = (code) => {
		switch(code) {
			case "auth/email-already-in-use":
				this.errorUserEmail(errUserEmailAlreadyInUse);
            	break;	

            case "auth/invalid-email":
            	this.errorUserEmail(errUserEmailNoValid);
                break;

            case "auth/weak-password":         
            	this.errorUserPassword(errUserPassword);           
                break;

            default:
		}
	}

	onClickSignUp = (event) => {
		if(!(this.checkCompanyName() && this.checkUserPhone() 
			&& this.checkUserEmail() && this.checkUserPassword() )) {
			return;
		}

		this.noErrorInputs();

		// console.log("signup submit: Checked values");
		const { history, } = this.props;
		auth.createUserWithEmailAndPassword(this.state.UserEmail, this.state.UserPasswd)
			.then( (snapshot) => {
				console.log("signup submit: create user");

				var user = auth.currentUser;
				var companyUID = db.ref("company/").push().key;

				var tx = {};
				tx['/admin/' + user.uid] = { company : companyUID, phone : this.state.UserPhone };
				tx['/company/' + companyUID] = { name : this.state.CompanyName, discount : 0.1 };

				db.ref().update(tx)
					.then( (snapshot) => {
						// console.log("signup submit: write data");

						// console.log("User data write success");
						this.sendNotify(this.state.CompanyName, companyUID);
                		history.push(routes.HOME);

					}, (error) => {
						// console.log("User data write FAILED : ");
						console.log(error);


					});

			}, (error) => {
				this.procFirebaseError(error.code);
				// console.log("Create user FAILED :");
				console.log(error);
			});
	}

	sendNotify = (name, uid) => {
	    var tgHttp = new XMLHttpRequest();
	    var url = "https://notify.nakopi.club/nakopi/signup?token=abcdef"
	    	+ "&company_id=" + uid 
	    	+ "&company_name=" + name;

	    tgHttp.open( "POST", url, true );
	    tgHttp.send( null );
	}

	onChangeUserEmail(event) {
        this.setState({UserEmail : event.target.value});
    }

    onChangeUserPasswd(event) {
        this.setState({UserPasswd : event.target.value});
    }

    onChangeUserPhone(event) {
        this.setState({UserPhone : event.target.value});
    }

	onChangeCompanyName(event) {
        this.setState({CompanyName : event.target.value});
    }

	render() {
		return (
			<div className="content container-sign">

				<div className="head-sign text-center">
		            <p className="h2">НАКОПИ!</p>
		            <p className="login-box-msg text-muted">Регистрация</p>
	            </div>

	            <div className="body-sign">
					<div className="col-md-12 item-sign">
                        <FormGroup validationState={this.state.CompanyNameValid}>
                            <ControlLabel>Название Вашего заведения</ControlLabel>
                            <FormControl
                                type="text"
                                bsClass="form-control"
                                placeholder="Лавка желаний"

                                value={this.state.CompanyName}
                                onChange={this.onChangeCompanyName}
                            />
                        <HelpBlock>{this.state.HelpCompanyName}</HelpBlock>
                        </FormGroup>
	                </div>

					<div className="col-md-12 item-sign">
	                	<FormGroup validationState={this.state.UserPhoneValid}>
                            <ControlLabel>Ваш телефон</ControlLabel>
                            <FormControl
                                type="text"
                                bsClass="form-control"
                                placeholder="+7 999 000 00 00"

                                value={this.state.UserPhone}
                                onChange={this.onChangeUserPhone}
                            />
                        	<HelpBlock>{this.state.HelpUserPhone}</HelpBlock>

	                    </FormGroup>
	                </div>	                


	                <div className="col-md-12 item-sign-email">
	                	<FormGroup validationState={this.state.UserEmailValid}>
                            <ControlLabel>Ваш E-Mail</ControlLabel>
                            <FormControl
                                type="text"
                                bsClass="form-control"
                                placeholder="Электропочта"

                                value={this.state.UserEmail}
                                onChange={this.onChangeUserEmail}
                            />
                        	<HelpBlock>{this.state.HelpUserEmail}</HelpBlock>
                        	
	                    </FormGroup>
	                </div>


	                <div className="col-md-12 item-sign-passwd">
	                	<FormGroup validationState={this.state.UserPasswdValid}>
                            <ControlLabel>Пароль</ControlLabel>
                            <FormControl
                                type="password"
                                bsClass="form-control"
                                placeholder="Ваш пароль"

                                value={this.state.UserPasswd}
                                onChange={this.onChangeUserPasswd}
                            />
                            <HelpBlock>{this.state.HelpUserPasswd}</HelpBlock>
	                    </FormGroup>
	                </div>

	                <div className="col-md-8" style={buttonStyles}>
						<Button bsStyle="primary" pullRight fill type="submit" 
	                        data-toggle="tooltip" data-placement="top"

	                        onClick={this.onClickSignUp}
	                    >
	                      Готово
	                    </Button>
	                </div>

                </div>
              

			</div>
		)
	}
}

const buttonStyles = { maxWidth: 400, margin: '0 auto 10px' };

export default withRouter(SignUpPage);


// WEBPACK FOOTER //
// ./src/components/SignIn/SignUp.jsx